{
  "name": "frontend",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "node set-build-info.js",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "test": "ng test",
    "test-watch": "ng test cms --watch",
    "test-coverage": "ng test --coverage",
    "test-ci": "ng test --no-watch --no-progress --browsers=ChromeHeadless",
    "analyze": "ng build --stats-json",
    "build:branch": "npm run prebuild && ng build --configuration=branch",
    "build:prod": "npm run prebuild && ng build --configuration=production",
    "i18n:keys": "transloco-keys-manager extract",
    "i18n:sync": "transloco-keys-manager extract --add-missing-keys --remove-extra-keys"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.11",
    "@angular/cdk": "^19.2.16",
    "@angular/common": "^19.2.11",
    "@angular/compiler": "^19.2.11",
    "@angular/core": "^19.2.11",
    "@angular/forms": "^19.2.11",
    "@angular/material": "^19.2.16",
    "@angular/platform-browser": "^19.2.11",
    "@angular/router": "^19.2.11",
    "@datx/core": "3.0.0",
    "@datx/jsonapi": "3.0.0",
    "@datx/jsonapi-angular": "3.0.0",
    "@datx/jsonapi-types": "3.0.0",
    "@datx/network": "3.0.0",
    "@datx/utils": "3.0.0",
    "@jsverse/transloco": "7.6.1",
    "@ngxs/devtools-plugin": "^19.0.0",
    "@ngxs/store": "^19.0.0",
    "@sentry/angular": "^9.1.0",
    "@wdidev/pixl-editor": "^0.0.87",
    "angular-split": "^20.0.0",
    "ngx-colors": "3.6.0",
    "rxjs": "7.8.2",
    "ts-md5": "1.3.1",
    "tslib": "^2.3.0",
    "turndown": "7.2.1",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-builders/jest": "^19.0.1",
    "@angular-devkit/build-angular": "^19.2.12",
    "@angular-devkit/core": "^19.2.12",
    "@angular-devkit/schematics": "^19.2.12",
    "@angular/build": "^19.2.12",
    "@angular/cli": "^19.2.12",
    "@angular/compiler-cli": "^19.2.11",
    "@angular/localize": "^19.2.11",
    "@angular/platform-browser-dynamic": "^19.2.11",
    "@jsverse/transloco-keys-manager": "7.1.0",
    "@stylistic/eslint-plugin": "5.6.1",
    "@testing-library/angular": "17.4.0",
    "@testing-library/dom": "10.4.1",
    "@testing-library/jest-dom": "6.9.1",
    "@types/jest": "30.0.0",
    "@types/node": "24.10.1",
    "@types/turndown": "5.0.6",
    "@typescript-eslint/utils": "8.48.0",
    "angular-eslint": "19.2.1",
    "eslint": "9.39.1",
    "jest": "30.2.0",
    "msw": "2.12.3",
    "prettier": "3.7.0",
    "source-map-explorer": "2.5.3",
    "typescript": "5.7.3",
    "typescript-eslint": "8.48.0"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
